import * as Sentry from '@sentry/react';
import { IUser } from 'src/types/user';

class TakerSentry {
  public provideContext = {
    user: (user: IUser) => {
      Sentry.setUser({
        username: user.name,
        id: user.id.toString(),
        email: user.email,
      });
      Sentry.setContext('admin_user', {
        username: user.name,
        role: user.role,
        permissions: user.permissions,
        id: user.id,
        branches: user.branches.map((branch) => branch.id),
        email: user.email,
      });
    },
  };

  public capture = (error: string, options?: { [key: string]: string }) => {
    let message = error;
    if (options) {
      Object.entries(options).forEach(([key, value]) => (message += `; ${key} - ${value}`));
    }
    // provide sentry user context
    // sentry.provi deContext.user(user);
    Sentry.captureException(new Error(message));
  };

  public tag = (key: string, value: string) => {
    Sentry.setTag(key, value);
  };
}

const sentry = new TakerSentry();

export default sentry;
